import type { UserPlan } from "@/types";
import i18n from "@/i18n";

/**
 * How many *active* small goals a user may hold at once (Free 3 / Plus 10).
 * Mirrors the API in backend/api/src/modules/goals/goal-limits.ts. An active
 * goal is any goal that has not been archived.
 */
export function activeGoalLimit(plan: UserPlan | undefined): number {
  return plan === "plus" ? 10 : 3;
}

/** Nudge shown when the board is full. */
export function goalSlotsFullCopy(savedGoals: number): string {
  return i18n.t("growth.dashboard.goalsFullBody", { count: savedGoals });
}
